import { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import api, { formatDetail } from "@/lib/api";

export default function BlacklistPage() {
  const [list, setList] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/blacklist"); setList(data); };
  useEffect(() => { load(); }, []);
  const unblock = async (phone) => { try { await api.delete(`/admin/customers/${phone}/blacklist`); toast.success("Removed"); load(); } catch (e) { toast.error(formatDetail(e.response?.data?.detail)); } };
  return (
    <AdminLayout title="Blacklist" showTurnBoard={false}>
      <div className="bg-white rounded-2xl border border-zen-border overflow-hidden">
        <table className="w-full">
          <thead className="bg-zen-surface text-xs uppercase text-zen-muted"><tr>
            <th className="text-left px-5 py-3">Name</th><th className="text-left px-5 py-3">Phone</th><th className="text-right px-5 py-3">Actions</th>
          </tr></thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.phone} className="border-t border-zen-border" data-testid={`blacklist-row-${c.phone}`}>
                <td className="px-5 py-4 font-medium">{c.name}</td>
                <td className="px-5 py-4 font-mono text-sm">{c.phone}</td>
                <td className="px-5 py-4 text-right"><Button size="sm" variant="outline" onClick={() => unblock(c.phone)} className="rounded-full" data-testid={`unblock-${c.phone}`}><ShieldCheck className="w-3 h-3 mr-1" /> Remove</Button></td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="3" className="text-center py-12 text-zen-muted">No blacklisted</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
